import APIClient from '@/shared/http/clients/api'

// const resourceName = 'margem-contribuicao'
const resourceName = 'risco'
const APICore = process.env.APIBaseURLCore

const Search = (document = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?document=${document}&page=${index}&size=${limit}&sort=periodoMovimento,desc`, config)

/**
 * @name RiscoRepository
 * @description Marge contribuição
 * @type { Respository }
 */
const RiscoRepository = {
  Search
}

export default RiscoRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/risco.js